import { Drawer, IconButton, Icon } from '@hevoio/hevo-ui-toolkit';
import { SetupGuideDocs } from '../../../../../docs/components/setup-guide-docs/SetupGuideDocs';
import { VPC_PEERING_ACCEPT_DOC_LINK } from '../CreateVPCModal/constants';
import { VPCPeeringConnection } from '../../interface';
import styles from './AcceptConnectionDrawer.module.scss';

export const AcceptConnectionDrawer = ({
  open,
  onClose
}: {
  open: boolean;
  connection?: VPCPeeringConnection | null;
  onClose: () => void;
}) => (
  <Drawer
    anchor='right'
    open={open}
    onClose={onClose}
    PaperProps={{ style: { width: 520, maxWidth: '90vw' }, className: styles.drawerPaper }}
  >
    <div className='d-flex justify-between align-items-center px-4 py-2 border-bottom w-100'>
      <p className='m-0 text-body-small text-strong-950'>
        Accept the VPC Peering Connection Request
      </p>
      <IconButton dataId='close-accept-drawer' label='' onClick={onClose}>
        <Icon name='close' />
      </IconButton>
    </div>

    <div className='flex-1 overflow-hidden w-100'>
      {open && (
        <SetupGuideDocs
          className='h-100'
          docLink={VPC_PEERING_ACCEPT_DOC_LINK}
          autoScrollToSectionOnLoad
        />
      )}
    </div>
  </Drawer>
);
